<div *ngIf="isLoggedIn;else login" class="dashboard-container" [class.sidebar-closed]="sidebarCollapsed">

  <!-- Overlay for mobile sidebar -->
  <div class="sidebar-overlay" [class.active]="!sidebarCollapsed" (click)="toggleSidebar()"></div>

  <!-- Main Content Area -->
  <main class="main-content">
    <app-header (menuToggle)="toggleSidebar()"></app-header>

    <!-- Breadcrumb Bar -->
    <div class="breadcrumb-bar" *ngIf="breadcrumbItems.length > 0">
      <div class="breadcrumb">
        <div class="breadcrumb-item" *ngFor="let item of breadcrumbItems; let i = index">
          
          <!-- Icon -->
          <svg *ngIf="item.icon" class="breadcrumb-icon" width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="item.icon"></path>
          </svg>

          <!-- Label / Action -->
          <ng-container *ngIf="item.action; else textOnly">
            <a href="javascript:void(0)" (click)="item.action()" class="breadcrumb-link">{{ item.label }}</a>
          </ng-container>
          <ng-template #textOnly>
            <span class="breadcrumb-current">{{ item.label }}</span>
          </ng-template>

          <!-- Chevron Divider -->
          <svg *ngIf="i < breadcrumbItems.length - 1" class="breadcrumb-divider" width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
          </svg>

        </div>
      </div>
    </div>

    <!-- Dynamic Content Area (Scrollable) -->
    <div class="content-area">
      <router-outlet></router-outlet>
    </div>
  </main>

  <!-- Sidebar (Fixed Left) - Moved to bottom for highest paint order -->
  <app-sidebar [isCollapsed]="sidebarCollapsed" (toggleSidebar)="toggleSidebar()"></app-sidebar>

</div>

<ng-template #login>
  <router-outlet></router-outlet>
</ng-template>

<app-confirmation-dialog></app-confirmation-dialog>
<app-toast></app-toast>
<app-offline-screen *ngIf="isOffline"></app-offline-screen>
<div class="app-loader" *ngIf="(loading || routeLoading) && !isNoSpinnerPage">
  <div class="app-loader-backdrop"></div>

  <div class="app-loader-content">
    <div class="app-spinner-wrapper">
      <svg class="app-spinner" viewBox="0 0 50 50">
        <circle class="app-spinner-path" cx="25" cy="25" r="20" fill="none" stroke-width="4">
        </circle>
      </svg>

      <div class="app-spinner-logo">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
        </svg>
      </div>
    </div>

    <p class="app-loader-text">Loading, please wait…</p>
  </div>
</div>